'use client';
import { atom, useAtom, useSetAtom, WritableAtom } from 'jotai';

// Z-index management atom - stores z-indexes by ID
export const zIndexAtom = atom<Record<string, number>>({}) as WritableAtom<
  Record<string, number>,
  [Record<string, number>],
  void
>;

export const setZIndexAtom = atom(null, (get, set, id: string, zIndex: number | null) => {
  const current = get(zIndexAtom);
  if (zIndex === null) {
    const { [id]: _, ...rest } = current;
    set(zIndexAtom, rest);
  } else {
    set(zIndexAtom, { ...current, [id]: zIndex });
  }
});

export function useZIndex(id: string) {
  const [zIndexMap] = useAtom(zIndexAtom);
  const setZIndex = useSetAtom(setZIndexAtom);
  const zIndex = zIndexMap[id] ?? null;

  return {
    zIndex,
    zIndexMap,
    setZIndex: (value: number | null) => setZIndex(id, value),
  };
}
